export default __webpack_public_path__ + "static/media/50.e0abf3ae.svg";